import { render, staticRenderFns } from "./class-update.vue?vue&type=template&id=5722c97f&"
import script from "./class-update.vue?vue&type=script&lang=js&"
export * from "./class-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports